import getUrl from "../get-domain"
import {
    spliteDate,
    humanizeNumber,
    fixFloatNumber,
    handleClassRederer,
    convertCurrency
} from "../market/functions"

import { showActivity, showAlarm, showAlarmClass } from "../market/common"
import { calculate_power_buy } from "../market/common"


const createLink = (row, filter) => {
    if (window.location.href.includes("http://127.0.0.1:3000")) {
        return `/market/symbol_list?date=${row.date}&stockFilter=${filter}`
    } else {
        return getUrl().REACT_APP_MARKET_SYMBOL_LIST_PAGE.replace(/{date}/g, row.date).replace(/{stockFilter}/g, filter)
    }
}


const config = [
    {
        value: 'تاریخ',
        renderer: (row, stock) => <a target="_blank" rel="noreferrer" href={createLink(row, stock)}>{spliteDate(row.date)}</a>
    },
    {
        value: 'ارزش معاملات',
        renderer: (row, stock) => humanizeNumber(convertCurrency(row.total_tval[stock])),
        direction: 'ltr'
    },
    {
        value: '5',
        renderer: (row, stock) => {
            if (row.total_tval[stock] !== undefined && row.tval_avg_5[stock] !== undefined) {
                return (row.total_tval[stock] / row.tval_avg_5[stock]).toFixed(2)
            }
        },
        className: (row, stock) => {
            if (row.total_tval[stock] !== undefined && row.tval_avg_5[stock] !== undefined) {
                return row.total_tval[stock] / row.tval_avg_5[stock] > 1 ? 'text-primary' : 'text-danger'
            }
        },
    },
    {
        value: '22',
        renderer: (row, stock) => {
            if (row.total_tval[stock] !== undefined && row.tval_avg_22[stock] !== undefined) {
                return (row.total_tval[stock] / row.tval_avg_22[stock]).toFixed(2)
            }
        },
        className: (row, stock) => {
            if (row.total_tval[stock] !== undefined && row.tval_avg_22[stock] !== undefined) {
                return row.total_tval[stock] / row.tval_avg_22[stock] > 1 ? 'text-primary' : 'text-danger'
            }
        },
    },
    {
        value: '60',
        renderer: (row, stock) => {
            if (row.total_tval[stock] !== undefined && row.tval_avg_60[stock] !== undefined) {
                return (row.total_tval[stock] / row.tval_avg_60[stock]).toFixed(2)
            }
        },
        className: (row, stock) => {
            if (row.total_tval[stock] !== undefined && row.tval_avg_60[stock] !== undefined) {
                return row.total_tval[stock] / row.tval_avg_60[stock] > 1 ? 'text-primary' : 'text-danger'
            }
        },
    },
    {
        value: 'قدرت',
        renderer: (row, stock) => (
            row.power_buy[stock] !== undefined && 
            row.power_buy[stock] !== null && 
            row.power_buy[stock].toFixed(2)
        ),
        className: (row, stock) => (
            row.power_buy[stock] !== undefined && 
            row.power_buy[stock] !== null && 
            handleClassRederer(row.power_buy[stock], 0)
        ),
        direction: 'ltr'
    },
    {
        value: 'قدرت 5',
        renderer: (row, stock) => (
            row.per_buy_5[stock] !== undefined && 
            row.per_sell_5[stock] !== undefined && 
            row.per_buy_5[stock] !== null && 
            row.per_sell_5[stock] !== null && 
            calculate_power_buy(row.per_buy_5[stock], row.per_sell_5[stock]).toFixed(2)
        ),
        className: (row, stock) => (
            row.per_buy_5[stock] !== undefined && 
            row.per_sell_5[stock] !== undefined && 
            row.per_buy_5[stock] !== null && 
            row.per_sell_5[stock] !== null && 
            handleClassRederer(row.per_buy_5[stock], row.per_sell_5[stock])
        ),
        direction: 'ltr'
    },
    {
        value: 'قدرت  22',
        renderer: (row, stock) => (
            row.per_buy_22[stock] !== undefined && 
            row.per_sell_22[stock] !== undefined && 
            row.per_buy_5[stock] !== null && 
            row.per_sell_5[stock] !== null && 
            calculate_power_buy(row.per_buy_22[stock], row.per_sell_22[stock]).toFixed(2)
        ),
        className: (row, stock) => (
            row.per_buy_22[stock] !== undefined && 
            row.per_sell_22[stock] !== undefined && 
            row.per_buy_5[stock] !== null && 
            row.per_sell_5[stock] !== null && 
            handleClassRederer(calculate_power_buy(row.per_buy_22[stock], row.per_sell_22[stock]), 0)
        ),
        direction: 'ltr'
    },
    {
        value: 'ورود',
        renderer: (row, stock) => humanizeNumber(convertCurrency(row.entry_money[stock])),
        className: (row, stock) => handleClassRederer(row.entry_money[stock], 0),
        direction: 'ltr'
    },
    {
        value: 'ورود 5',
        renderer: (row, stock) => (
            row.entry_money_5 !== undefined && 
            humanizeNumber(convertCurrency(row.entry_money_5[stock]))
        ),
        className: (row, stock) => (
            row.entry_money_5 !== undefined && 
            handleClassRederer(row.entry_money_5[stock], 0)
        ),
        direction: 'ltr'
    },
    {
        value: 'ورود 22',
        renderer: (row, stock) => (
            row.entry_money_22 !== undefined &&
            convertCurrency(row.entry_money_22[stock])
        ),
        className: (row, stock) => (
            row.entry_money_22 !== undefined &&
            handleClassRederer(row.entry_money_22[stock], 0)
        ),
        direction: 'ltr'
    },
    {
        value: 'آخپا',
        renderer: (row, stock) => humanizeNumber(row.pplc[stock]),
        className: (row, stock) => handleClassRederer(row.pplc[stock], 0),
        direction: 'ltr'
    },
    {
        value: 'آخفرست',
        renderer: (row, stock) => humanizeNumber(row.pplf[stock]),
        className: (row, stock) => handleClassRederer(row.pplf[stock], 0),
        direction: 'ltr'
    },
    {
        value: 'سایه',
        renderer: (row, stock) => humanizeNumber(row.pshadow[stock]),
        className: (row, stock) => handleClassRederer(row.pshadow[stock], 0),
        direction: 'ltr'
    },
    {
        value: "اشی",
        renderer: (row) => row.ch > row.oh ? 'سبز' : 'قرمز',
        className: (row) => row.ch > row.oh ? 'text-primary' : 'text-danger',
    },
    {
        value: "اوسیلاتور",
        renderer: (row) => row.new_ao,
        className: (row) => row.new_ao === 'قرمز' ? 'text-danger' : 'text-primary',
    },
    {
        value: "ک.ب.ا",
        renderer: (row) => row.cloud ? 'بالای ابر' : 'زیر ابر',
        className: (row) => handleClassRederer(row.cloud, 0),
    },
    {
        value: "شاخص کل",
        renderer: (row, stock) => humanizeNumber(row.close.toFixed(0))
    },
    {
        value: "ت.ش.ک",
        renderer: (row, stock) => (row.percent && row.percent.toFixed(2)),
        className: (row, stock) => handleClassRederer(row.percent, 0),
        direction: 'ltr'
    },
    {
        value: "هموزن",
        renderer: (row, stock) => row.types && row.types.totalequel_weithed && humanizeNumber(row.types.totalequel_weithed.value)
    },
    {
        value: "تغییر هموزن",
        renderer: (row, stock) => fixFloatNumber(row.totalequel_weithed_percent),
        className: (row, stock) => handleClassRederer(row.totalequel_weithed_percent, 0),
        direction: 'ltr'
    },
    {
        value: "نمره",
        renderer: (row, stock) => row.score !== undefined && row.score[stock],
        className: (row, stock) => row.score !== undefined && handleClassRederer(row.score[stock], 0),
        direction: 'ltr'
    },
    {
        value: "موثر",
        renderer: (row, stock) => row.effective_money !== undefined && humanizeNumber(convertCurrency(row.effective_money[stock])),
        className: (row, stock) => row.effective_money !== undefined && handleClassRederer(row.effective_money[stock], 0),
        direction: 'ltr'
    },
    {
        value: "5 سطر",
        renderer: (row, stock) => (
            row.resultant !== undefined && 
            row.resultant[stock] !== undefined && 
            humanizeNumber(convertCurrency(row.resultant[stock]['buy'] - row.resultant[stock]['sell']))
        ),
        className: (row, stock) => (
            row.resultant !== undefined && 
            row.resultant[stock] !== undefined && 
            handleClassRederer(row.resultant[stock]['buy'] - row.resultant[stock]['sell'], 0)
        ),
        direction: 'ltr'
    },
    {
        value: "آلارم",
        renderer: (row, stock) => row.alarm !== undefined && showAlarm(row, stock),
        className: (row, stock) => row.alarm !== undefined && showAlarmClass(row, stock)
    },
    {
        value: "فعالیت",
        renderer: (row, stock) => row.alarm !== undefined && showActivity(row, stock),
        className: (row, stock) => row.alarm !== undefined && showAlarmClass(row, stock),
    },
    {
        value: 'حرف',
        renderer: (row, stock) => row.alarm_letter !== undefined && row.alarm_letter[stock] && row.alarm_letter[stock].toLowerCase(),
        className: (row, stock) => {
            if (row.alarm_letter !== undefined) {
                if (['E', 'K', 'F'].includes(row.alarm_letter[stock])) {
                    return 'text-primary'
                } else if (['H', 'J', 'G', 'I', 'N'].includes(row.alarm_letter[stock])) {
                    return 'text-danger'
                }
            }
        }
    }
]

export { config }